import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../../../constants/enums";
import { defaultBusinessPolicySOVState } from "./businessPolicySOV.types";
import {
  fetchSOVList,
  fetchLeadSOVListAsync,
  importSOV,
} from "./businessPolicySOVActions";
import { APIError } from "../../../constants/types";

const businessPolicySOVSlice = createSlice({
  name: "businessPolicySOV",
  initialState: defaultBusinessPolicySOVState,
  reducers: {
    clearBusinessPolicySOVState: () => {
      return defaultBusinessPolicySOVState;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchSOVList
      .addCase(fetchSOVList.pending, (state) => {
        state.list.loading = LoadState.InProgress;
        state.list.data = [];
      })
      .addCase(fetchSOVList.fulfilled, (state, action) => {
        state.list.loading = LoadState.Loaded;
        state.list.data = action.payload.data;
        state.list.totalRecords = action.payload.totalRecords;
      })
      .addCase(fetchSOVList.rejected, (state) => {
        state.list.loading = LoadState.Failed;
        state.list.data = [];
      })
      // fetchLeadSOVListAsync (lead-binder-additional-tabs) — mirrors fetchSOVList.
      // On failure the list is flipped to Failed so the sub-tab can surface retry.
      .addCase(fetchLeadSOVListAsync.pending, (state) => {
        state.list.loading = LoadState.InProgress;
        state.list.data = [];
      })
      .addCase(fetchLeadSOVListAsync.fulfilled, (state, action) => {
        state.list.loading = LoadState.Loaded;
        state.list.data = action.payload.data;
        state.list.totalRecords = action.payload.totalRecords;
      })
      .addCase(fetchLeadSOVListAsync.rejected, (state) => {
        state.list.loading = LoadState.Failed;
        state.list.data = [];
      })
      // importSOV
      .addCase(importSOV.pending, (state) => {
        state.submission.loading = LoadState.InProgress;
        state.submission.error = null;
      })
      .addCase(importSOV.fulfilled, (state) => {
        state.submission.loading = LoadState.Loaded;
        state.submission.error = null;
      })
      .addCase(importSOV.rejected, (state, action) => {
        state.submission.loading = LoadState.Failed;
        state.submission.error =
          (action.payload as APIError)?.message || "An error occurred";
      });
  },
});

export const { clearBusinessPolicySOVState } =
  businessPolicySOVSlice.actions;

export const businessPolicySOVReducer = businessPolicySOVSlice.reducer;
